module.exports = __webpack_public_path__ + "img/exposicaoPermanenteVermelho.d1a3989a.svg";